import React from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const BasicInfoSection = ({
  name,
  setName,
  description,
  setDescription,
}: {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  description: string;
  setDescription: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_register.basic_info.title")}
      rows={[
        {
          label: t("quest_register.basic_info.form.name.label"),
          required: true,
          children: (
            <TextField
              size="small"
              placeholder={t(
                "quest_register.basic_info.form.name.placeholder",
              )}
              sx={{ width: "50%" }}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          ),
        },
        {
          label: t("quest_register.basic_info.form.description.label"),
          children: (
            <TextField
              size="small"
              multiline
              rows={4}
              placeholder={t(
                "quest_register.basic_info.form.description.placeholder",
              )}
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          ),
        },
      ]}
    />
  );
};

export default BasicInfoSection;
